"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import { ExploreCard } from "./ExploreCard";

export function Explore({ exploreComponentSlot = "" }) {
  return (
    <Block className={"explore_component"} tag={"div"}>
      {exploreComponentSlot ?? (
        <>
          <ExploreCard
            altText={"__wf_reserved_inherit"}
            image={
              "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/661567ea03a6003b067feff4_preston%20at%20m%20mile.jpeg"
            }
            link={{
              href: "/search/?www.srgliving.com[refinementList][type][0]=multiFamily",
            }}
          />
          <Block className={"explore_spacer"} tag={"wrapper"} />
          <ExploreCard
            altText={"custom alt tag here"}
            image={
              "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/66154e9865c9d61893023c40_55%2B.jpeg"
            }
            link={{
              href: "/search/?www.srgliving.com%5BrefinementList%5D%5Btype%5D%5B0%5D=senior",
            }}
            text={"55+ and Better"}
          />
          <Block className={"explore_spacer"} tag={"wrapper"} />
          <ExploreCard
            image={
              "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/66154e98b7c1ab00e31f338f_singlefamily.jpeg"
            }
            link={{
              href: "/search/?www.srgliving.com%5BrefinementList%5D%5Btype%5D%5B0%5D=singleFamily",
            }}
            text={"Single Family Residences & Townhomes"}
          />
        </>
      )}
    </Block>
  );
}
